
import Navbar from "./Navbar";
import Hero from "./Hero";
import Contact from "./Contact";
function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Contact />
    </>
  );
}

export default App;
